var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pic"},[_c('div',{staticClass:"icon",class:{'locked' : _vm.locked}},[_c('img',{attrs:{"src":'https://web-resource.17m3.com/cdn/m3-eq/'+ _vm.id +'.jpg',"alt":"","srcset":""}}),_vm._v(" "),(_vm.num > 1)?_c('div',{staticClass:"item-num"},[_vm._v(_vm._s(_vm.num))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8b4ea22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/itemView.vue
// module id = null
// module chunks = 